import { CompetentionsSpider } from './CompetentionsSpider';

export default CompetentionsSpider;